export enum GeneralParameterEnums {
  retefuenteEnFactura = 1,
  reteIvaEnFactura = 2,
  reteIcaEnFactura = 3,
  retencionTotalEnFactura = 4,
  generaCuentaCobro = 5,
  autoretencionesEnInterfaz = 6,
  facturaServiciosAparte = 7,
  serviciosFullAparte = 8,
  tipoServicio = 9,
  saldoCartera = 10,
  moduloPedidos = 11,
  facturacionEspecial = 12,
  ImprimirBodegaDocumento = 13,
  moduloCotizaciones = 14,
  obligaCotizacionesPedido = 15,
  generaFletes = 16,
  ordenesDeMantenimiento = 17,
  moduloCompras = 18,
  despachoEquipoSinPedido = 19,
  despachoAccesorioSinPedido = 20,
  articuloGenerico = 21,
  confirmaTrasladoBodega = 22,
  manejaRemisionesVenta = 23,
  imprimeEquiposReparacion = 24,
  facturacionParcial = 25,
  facturaMandato = 26,
  reservation = 28,
  manejaInventarioDeInsumos = 29,
  servicioRequierePedido = 30,
  confirmaTrasladoObra = 31,
  estrategiaMantenimiento = 32,
  ordenMatenimientoProgramada = 33,
  facturaAnticipada = 34,
  cambioAutoCcoAFraVencida = 35,
  permitirNegativosAlmacen = 36,
  tareaArticulos = 37,
  habilitarLimpiezaEnDevoluciones = 38,
  activaSolicitudesDeNotas = 39,
  indicadores = 40,
  mostrarSoloDespiecePedidos = 41,
  activaModelosContables = 42,
  imprimirEquipoReparado = 43,
  generarPedidoDesdeCotizacion = 44,
  generarSuspensionesOM = 45,
  appMovil = 48,
}